<template>
  <div class="container">
    <div class="header">
      <div id="navigation-back" @click.prevent="back">
        <figure id="back-figure">
          <img src="../../static/img/back.png" alt="Volver">
        </figure>
      </div>
      <div id="navigation-home" @click.prevent="goInicio">
        <figure id="home-figure">
            <img src="../../static/img/home.png" alt="Inicio">
        </figure>
      </div>
    </div>
    <div class="section">
      <div class="logo">
        <figure>
          <img src="../assets/logo.png" alt="DIRECTV">
        </figure>
      </div>
      <div id="participanteConfirmacion">
        <h2>Datos del Participante</h2>
        <p>DNI: {{ participante.documentoNumero }} </p>
        <p>Apellido/s: {{ participante.apellido }} </p>
        <p>Nombre/s: {{ participante.nombre }} </p>
        <p>Sexo: {{ participante.sexo }} </p>
        <p>Fecha de Nac.: {{ participante.fechaNacimiento }} </p>
        <p :class="{ displayNumberError: ageError }">Edad: {{ edad }} </p>
      </div>
      <b-button class="link" v-if="!ageError"
        @click.prevent="save">ENVIAR</b-button>
    </div>
    <b-alert
      v-model="ageError"
      variant= "warning">
      <p>Para participar, debe ser mayor de 18 años</p>
    </b-alert>    
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      participante: {}
    }
  },
  created () {
    if (!this.$store.getters['settings/testing']) {
      if (!this.$store.getters['user/loggedIn']) {
        this.$router.push({ name: 'Login' });
      }

      var evento = this.$store.getters['eventos/evento'];
      if (!evento) {
        this.$router.push({ name: 'SeleccionEvento' });
      }
    }

    this.participante = this.$store.getters['participante/participante'];
  },
  methods: {
    save () {
      this.$router.push({ name: 'IngresoEsCliente' });
      /*this.$router.push({ name: 'IngresoCelularTeclado' });*/
    },
    back () {
      this.$router.go(-1)
    },
    goInicio () {
      this.$router.push({ name: 'Inicio' });
    },
  },
  computed: {
    edad: function() {
      var fechaNacimiento = moment(this.participante.fechaNacimiento, "DD/MM/YYYY");
      return Math.abs(fechaNacimiento.diff(moment(), 'years'));
    },
    ageError: function() {
      var fechaNacimiento = moment(this.participante.fechaNacimiento, "DD/MM/YYYY");
      var edad = Math.abs(fechaNacimiento.diff(moment(), 'years'));
      return (edad < 18);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/IngresoCamaraConfirmacion.vue